import React, { FC, ReactElement } from "react";
import InputMask from "react-input-mask";

import TextField from "ui/TextField/TextField";

type Props = Partial<{
  mask: string;
  value: string;
  maskChar: string;
  alwaysShowMask: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  error: React.ReactChild;
  type: string;
  label: string;
  autoFocus?: boolean;
  className?: string;
  success: boolean;
  disabled: boolean;
  postfix: ReactElement | Element | string;
  onFocus?: (e: React.FocusEvent) => void;
  largeFromTablet?: boolean;
}>;

const TextFieldMask: FC<Props> = React.forwardRef(
  (
    { mask, value, onChange, maskChar, alwaysShowMask, error, ...other }: Props,
    ref
  ): ReactElement => {
    return (
      <InputMask
        mask={mask}
        value={value}
        onChange={onChange}
        maskChar={maskChar}
        alwaysShowMask={alwaysShowMask}
        {...other}
      >
        {inputProps => <TextField ref={ref} {...inputProps} error={error} />}
      </InputMask>
    );
  }
);

export default TextFieldMask;
